<ion-content class="ion-padding">
    <ion-grid>
        <ion-row>
            <ion-col>
                <ion-text color="primary">
                    <h3 class="ion-text-center">{{callerName}}</h3>
                </ion-text>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col class="ion-text-center">
                <img alt="avatar" class="avatar" src="/assets/img/avatar.png"/>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col>
                <ion-text color="primary">
                    <h4 class="ion-text-center">Es klingelt</h4>
                </ion-text>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col class="ion-text-right">
                <ion-button (click)="acceptCall()" color="secondary" shape="round">
                    <ion-icon  slot="icon-only" name="call"></ion-icon>
                </ion-button>
            </ion-col>
            <ion-col class="ion-text-left">
                <ion-button (click)="cancelCall()" class="hangupIcon" color="danger" shape="round">
                    <ion-icon slot="icon-only" name="call"></ion-icon>
                </ion-button>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>
